import tinycolor from 'tinycolor2';

var Theme;
(function (Theme) {
  Theme.getLight = function (primaryColor) {
    return {
      radioIndicator: tinycolor(primaryColor.value).darken(20).toHslString(),
      radioBorder: '$deepBlue6',
      radioHoverBg: 'transparent',
      radioHoverBorder: tinycolor(primaryColor.value).darken(20).toHslString(),
      radioFocusBorder: tinycolor(primaryColor.value).darken(20).toHslString(),
      radioDisabledBg: '$deepBlue3',
      radioDisabledBorder: '$deepBlue5',
      radioIndicatorDisabledBg: tinycolor(primaryColor.value).setAlpha(0.6).toHslString()
    };
  };
  Theme.getDark = function (primaryColor) {
    return {
      radioIndicator: '$primary',
      radioBorder: '$deepBlue6',
      radioHoverBg: '$deepBlue3',
      radioHoverBorder: '$primary',
      radioFocusBorder: '$primary',
      radioDisabledBg: '$deepBlue3',
      radioDisabledBorder: '$deepBlue4',
      radioIndicatorDisabledBg: tinycolor(primaryColor.value).setAlpha(0.6).toHslString()
    };
  };
})(Theme || (Theme = {}));

export { Theme };
